import React from "react";
import { Grid, makeStyles, Typography, Button, Divider } from "@material-ui/core";
import { SubmitButton, SwitchStatus, MobileContainerAnimation, Debug, LinkAnimation } from "../../../../";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import Rating from "@material-ui/lab/Rating";
import * as Yup from "yup";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    content: {
      padding: "80px 8px 8px 8px",
      width: "100%"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    dFlexAlignItemsCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    mt12: {
      marginTop: "12px"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    },
    dFlexJustifySpaceAround: {
      display: "flex",
      width: "100%",
      justifyContent: "space-around"
    }
  };
});

var MobileCampusSatisfaction = function MobileCampusSatisfaction(props) {
  // console.log("MobileCampusSatisfaction", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classses: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.title || "Your opinion is important for us" : "Your opinion is important for us"))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      var initialValuesSatisfaction = {
        recommends: {
          sportmadness: "",
          service: "",
          repeat: ""
        },
        metrics: [{
          name: "activities",
          rating: ""
        }, {
          name: "trainers",
          rating: ""
        }, {
          name: "venues",
          rating: ""
        }, {
          name: "app",
          rating: ""
        }],
        comments: {
          improve: "",
          highlights: ""
        }
      };
      var satisfactionSchema = Yup.object().shape({
        recommends: Yup.object().shape({
          sportmadness: Yup.number().required().min(1),
          service: Yup.number().required().min(1),
          repeat: Yup.bool().required()
        }),
        metrics: Yup.array().of(Yup.object().shape({
          name: Yup.string().required(),
          rating: Yup.number().required().min(1)
        })),
        comments: Yup.object().shape({
          improve: Yup.string().required(),
          highlights: Yup.string().required()
        })
      });
      return /*#__PURE__*/React.createElement(Formik, {
        initialValues: props.data ? props.data.form || initialValuesSatisfaction : initialValuesSatisfaction,
        validationSchema: satisfactionSchema,
        onSubmit: function onSubmit(values) {
          props.data.handleSubmit(values);
        },
        render: function render(_ref) {
          var values = _ref.values,
              isValid = _ref.isValid,
              isSubmitting = _ref.isSubmitting,
              setFieldValue = _ref.setFieldValue;
          return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
            container: true,
            spacing: 2
          }, /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.recommends ? props.translation.recommends.sportmadness || "How likely is it that you recommend Sportmadness to a friend or acquaintance?" : "How likely is it that you recommend Sportmadness to a friend or acquaintance?" : "How likely is it that you recommend Sportmadness to a friend or acquaintance?"), /*#__PURE__*/React.createElement(Rating, {
            value: values.recommends.sportmadness,
            name: "recommends.sportmadness",
            onChange: function onChange(e, v) {
              return setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            disabled: props.data ? props.data.disabled : false,
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.recommends ? props.translation.recommends.repeat || "Would you participate again in the camp?" : "Would you participate again in the camp?" : "Would you participate again in the camp?"), /*#__PURE__*/React.createElement("div", {
            className: classes.dFlexJustifySpaceAround
          }, /*#__PURE__*/React.createElement(Button, {
            variant: values.recommends.repeat ? "contained" : "outlined",
            color: "primary",
            disabled: props.data ? props.data.disabled : false,
            onClick: function onClick() {
              setFieldValue("recommends.repeat", true);
            }
          }, props.translation ? props.translation.buttons ? props.translation.buttons.yes || "Yes" : "Yes" : "Yes"), /*#__PURE__*/React.createElement(Button, {
            variant: values.recommends.repeat === false ? "contained" : "outlined",
            disabled: props.data ? props.data.disabled : false,
            color: "secondary",
            onClick: function onClick() {
              setFieldValue("recommends.repeat", false);
            }
          }, props.translation ? props.translation.buttons ? props.translation.buttons.no || "No" : "No" : "No"))), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.recommends ? props.translation.recommends.service || "How likely are you to recommend this camp to a friend or acquaintance?" : "How likely are you to recommend this camp to a friend or acquaintance?" : "How likely are you to recommend this camp to a friend or acquaintance?"), /*#__PURE__*/React.createElement(Rating, {
            value: values.recommends.service,
            name: "recommends.service",
            disabled: props.data ? props.data.disabled : false,
            onChange: function onChange(e, v) {
              return setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.metrics ? props.translation.metrics.activities || "The programming of activities has been varied and fun for my son / daughter" : "The programming of activities has been varied and fun for my son / daughter" : "The programming of activities has been varied and fun for my son / daughter"), /*#__PURE__*/React.createElement(Rating, {
            value: values.metrics.find(function (metric) {
              return metric.name === "activities";
            }).rating,
            name: "metrics[".concat(values.metrics.findIndex(function (metric) {
              return metric.name === "activities";
            }), "].rating"),
            disabled: props.data ? props.data.disabled : false,
            onChange: function onChange(e, v) {
              setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.metrics ? props.translation.metrics.trainers || "The monitors had the necessary experience to carry out the activities." : "The monitors had the necessary experience to carry out the activities." : "The monitors had the necessary experience to carry out the activities."), /*#__PURE__*/React.createElement(Rating, {
            value: values.metrics.find(function (metric) {
              return metric.name === "trainers";
            }).rating,
            name: "metrics[".concat(values.metrics.findIndex(function (metric) {
              return metric.name === "trainers";
            }), "].rating"),
            disabled: props.data ? props.data.disabled : false,
            onChange: function onChange(e, v) {
              return setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.metrics ? props.translation.metrics.venues || "The venues for carrying out the activities were adequate" : "The venues for carrying out the activities were adequate" : "The venues for carrying out the activities were adequate"), /*#__PURE__*/React.createElement(Rating, {
            value: values.metrics.find(function (metric) {
              return metric.name === "venues";
            }).rating,
            name: "metrics[".concat(values.metrics.findIndex(function (metric) {
              return metric.name === "venues";
            }), "].rating"),
            disabled: props.data ? props.data.disabled : false,
            onChange: function onChange(e, v) {
              return setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, props.translation ? props.translation.metrics ? props.translation.metrics.app || "The App has been a useful tool to receive information about the development of the camp" : "The App has been a useful tool to receive information about the development of the camp" : "The App has been a useful tool to receive information about the development of the camp"), /*#__PURE__*/React.createElement(Rating, {
            value: values.metrics.find(function (metric) {
              return metric.name === "app";
            }).rating,
            name: "metrics[".concat(values.metrics.findIndex(function (metric) {
              return metric.name === "app";
            }), "].rating"),
            disabled: props.data ? props.data.disabled : false,
            onChange: function onChange(e, v) {
              return setFieldValue(e.target.name, v);
            },
            icon: /*#__PURE__*/React.createElement(StarIcon, {
              color: "primary"
            }),
            emptyIcon: /*#__PURE__*/React.createElement(StarBorderIcon, {
              color: "primary"
            })
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: [classes.mt8, classes.dFlexAlignItemsCenter].join(" ")
          }, /*#__PURE__*/React.createElement(Field, {
            component: TextField,
            label: props.translation ? props.translation.comments ? props.translation.comments.highlights || "What would you highlight about the camp?" : "What would you highlight about the camp?" : "What would you highlight about the camp?",
            name: "comments.highlights",
            disabled: props.data ? props.data.disabled : false,
            variant: "outlined",
            fullWidth: true,
            multiline: true,
            rows: 4,
            margin: "normal"
          })), /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 12,
            className: classes.mt8
          }, /*#__PURE__*/React.createElement(Field, {
            component: TextField,
            label: props.translation ? props.translation.comments ? props.translation.comments.improve || "What can we improve?" : "What can we improve?" : "What can we improve?",
            name: "comments.improve",
            disabled: props.data ? props.data.disabled : false,
            variant: "outlined",
            fullWidth: true,
            multiline: true,
            rows: 4,
            margin: "normal"
          }))), props.data ? !props.data.disabled ? /*#__PURE__*/React.createElement(Grid, {
            container: true,
            className: classes.dFlexJustifySpaceAround
          }, /*#__PURE__*/React.createElement(LinkAnimation, {
            to: "/app/satisfaction",
            direction: "right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "button",
            size: "medium",
            className: classes.mr30,
            color: "secondary",
            variant: "outlined"
          }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Button, {
            size: "medium",
            color: "primary",
            variant: "outlined",
            disabled: !isValid || isSubmitting,
            component: SubmitButton,
            type: "submit"
          }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Rate" : "Rate" : "Rate")) : null : null);
        }
      });
    }
  })));
};

export { MobileCampusSatisfaction };